import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next'; import { getPreliminaryQuestionByLanguage } from 'utils/browserUtil';
import DropDownSelector from 'components/DropDownSelector';

import './styles.scss';


const GenderQuestion = ({
    updateAnswers, gender, genders, languageId
}) => {
    return (
        <div className='options-container'>
            <div className='desktop-options' style={ { width: '270px' } }>
                {genders.slice(0, -1).map((genderOption, idx) => {
                    return (
                        <div key={ idx } className='input-option'>
                            {genderOption.id !== 13 && <input type='radio' checked={ genderOption.id === gender.id } onChange={ () => updateAnswers('gender', genderOption) } />}
                            <span>{getPreliminaryQuestionByLanguage(genderOption, languageId)}</span>
                        </div>
                    );
                })}
            </div>
            <div className='mobile-options'>
                <DropDownSelector
                    selected={ gender.value ? gender : { value: null, title: i18n.t('motivator.please_select') } }
                    options={ genders.slice(0, -1).map(genderOption => ({ value: genderOption.id, title: getPreliminaryQuestionByLanguage(genderOption, languageId) })) }
                    callBack={ (option) => updateAnswers('gender', option) } />
            </div>
            <span
                className={ `prefer-not-to-say ${ genders.slice(-1)[0] && gender.id === genders.slice(-1)[0].id ? 'selected' : '' }` }
                onClick={ () => updateAnswers('gender', genders.slice(-1)[0]) }>
                {i18n.t('motivator.prefer_not_to_say')}
            </span>
        </div>
    );
};

GenderQuestion.propTypes = {
    updateAnswers: PropTypes.func,
    gender: PropTypes.object,
    genders: PropTypes.array,
    languageId: PropTypes.number

};

GenderQuestion.defaultProps = {
    updateAnswers: null,
    gender: null,
    genders: [],
    languageId: 1
};

export default GenderQuestion;
